<template>
  <RegisterForm
    :show-left-panel="true"
    :show-logo-link="true"
    :show-language-selector="true"
    :show-recaptcha="true"
    :enable-redirect="true"
    :redirect-url="redirectUrl"
    @register-success="handleRegisterSuccess"
    @register-error="handleRegisterError"
    @goto-login="handleGotoLogin"
    @google-register="handleGoogleRegister"
    @goto-email-verification="handleGotoEmailVerification"
  />
</template>

<script setup>
import RegisterForm from "../components/RegisterForm.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const redirectUrl = computed(() => {
  const baseUrl = window.location.origin;
  const redirect = route.query.redirect;
  return redirect ? baseUrl + redirect : window.location.href;
});

function handleRegisterSuccess(data) {
  // Registration success is handled by RegisterForm's internal redirect logic
  console.log("Register successful:", data);
}

function handleRegisterError(error) {
  // Error handling is managed by RegisterForm
  console.log("Register error:", error);
}

function handleGotoLogin() {
  // Login navigation is handled by RegisterForm's internal redirect logic
  console.log("Navigating to login");
}

function handleGoogleRegister() {
  // Google register is handled by RegisterForm's internal logic
  console.log("Google register initiated");
}

function handleGotoEmailVerification(email) {
  // Email verification navigation is handled by RegisterForm's internal redirect logic
  console.log("Navigating to email verification for:", email);
}
</script>

<style scoped>
.signup-footer-links {
  cursor: pointer;
  color: #0056b3;
  text-decoration: none;
}
</style>
